import { QueryColumn } from "./QueryColumn";

export class SingleQueryColumn extends QueryColumn {
    canHaveChildren() : boolean {
        return false;
    }

    renumberColumnsImpl = (from:number[]) => {
        this._columnNumber = from[0];
        from[0] = from[0]+1;
    }

    children() { 
        return [];
    }
}